import { isDescLang } from '@/settings/i18n';

export const getFullName = (
  firstName: string,
  lastName: string,
  separator = ' ',
): string => {
  if (isDescLang()) {
    return [lastName.trim(), firstName.trim()].join(separator);
  }

  return [firstName.trim(), lastName.trim()].join(separator);
};

export const classifiedSort = <T>(elems: T[]): T[] => {
  return isDescLang() ? elems.reverse() : [...elems];
};
